<template>
  <div
    id="app"
    v-wechat-title='$route.meta.title'
    img-set="/static/favicon.png"
  >
    <keep-alive :include="keepAliveComponents">
      <router-view
        :key="snowId"
        v-if="$route.name === 'Home'"
      />
      <router-view v-else />
    </keep-alive>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      snowId: '',
    };
  },
  computed: {
    ...mapState({
      keepAliveComponents: state => state.keepAliveComponents,
    }),
  },
  watch: {
    $route: {
      /*
      * 录播页面: 相同组件解决路由切换，页面不更新
      */
      handler(v) {
        if (v.name === 'Home') {
          this.snowId = v.query.snowId;
        }
        let type = 3;
        if (v.fullPath.indexOf('/app')) {
          type = 1;
        }

        /*
        * 记录在哪个设备打开
        * 渠道类型 1:微医直播app 2:微医app 3:h5
        */
        if (!window.sessionStorage.getItem('channel')) {
          window.sessionStorage.setItem('channel', type);
        }
      },
    },
  },
};
</script>

<style lang="less">
</style>
